<i18n>
{
  "en" :
  {
    "local" :
    {
      "actions":
      {
        "contact": "Contact",
        "submit": "Submit"
      },
      "fields":
      {
        "schema": "Schema",
        "password": "Password",
        "welcome": "Welcome"
      },
      "msg":
      {
        "account_expired": "The end date of access of this user to the application is over.",
        "account_locked": "This account is locked.",
        "error-setting-account": "Error setting on user account",
        "link": "link to Duck Creek Technologies website",
        "login_invalid": "Wrong username or password.",
        "technical_error": "An internal error occured."
      },
      "tooltips": {
        "logo": "Duck Creek Technologies' logo"
      }
    }
  },
  "fr" :
  {
    "local" :
    {
      "actions":
      {
        "contact": "Contact",
        "submit": "Valider"
      },
      "fields":
      {
        "schema": "Schéma",
        "password": "Mot de passe",
        "welcome": "Bienvenue"
      },
      "msg":
      {
        "account_expired": "La date de fin d'accès à l'application, de cet utilisateur, est dépassée.",
        "account_locked": "Compte bloqué.",
        "error-setting-account": "Erreur de paramétrage sur le compte utilisateur",
        "login_invalid": "Nom d'utilisateur ou mot de passe incorrect.",
        "link": "lien vers le site de Duck Creek Technologies",
        "technical_error": "Une erreur interne s'est produite."
      },
      "tooltips": {
        "logo": "Logo de Duck Creek Technologies"
      }
    }
  }
}
</i18n>

<template>
  <div class="ui-sign-in compliance">
    <div class="left">
      <h1>{{ $t("local.fields.welcome") }}</h1>
      <v-form @submit.prevent="login">
        <compliance-text
          id="formLoginUsername"
          v-model.trim="username"
          :disabled="isLogging"
          :label="$t('global.concepts.sysuser')"
          :outlined="false"
          required
        />

        <compliance-password
          id="formLoginPassword"
          v-model.trim="password"
          :disabled="isLogging"
          :label="$t('local.fields.password')"
          :outlined="false"
          :rules="[]"
          required
        />

        <v-container>
          <v-layout column>
            <v-flex class="mt-5" text-center>
              <v-btn
                class="mr-1"
                id="button"
                ref="btnLogIn"
                :loading="isLogging"
                color="primary"
                depressed
                type="submit"
              >
                <v-icon left>pic-key</v-icon>
                {{ $t("local.actions.submit") }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <a
        href="https://www.duckcreek.com/"
        :title="$t('local.msg.link')"
        class="logo-prima"
      >
        <img
          :alt="$t('local.tooltips.logo')"
          src="@/assets/duck-dct-color.svg"
          width="245"
          height="58"
        />
      </a>
    </div>
    <div class="right">
      <div class="logo">
        <h1>Duck creek <strong>Compliance</strong></h1>
      </div>
      <h2>{{ $t("global.header.title") }}</h2>
    </div>
  </div>
</template>

<script>
import { post } from "@/model/api";
import ComplianceText from "@/components/ComplianceText";
import CompliancePassword from "@/components/CompliancePassword";

export default {
  name: "UserLogin",

  components: {
    ComplianceText,
    CompliancePassword,
  },

  data() {
    return {
      show: false,
      username: "",
      password: "",

      isLogging: false,
    };
  },

  methods: {
    async login() {
      this.isLogging = true;

      const loginData = {
        username: this.username,
        password: this.password,
        rememberMe: false,
      };

      await post("/authenticate", loginData)
        .then((response) => {
          this.$store.commit("setLoginDetails", {
            response: response,
            username: this.username,
            i18n: this.$root.$i18n,
          });
        })
        .catch((error) => {
          this.isLogging = false;

          switch (error.status) {
            case 401:
              this.$store.commit("showError", error);
              break;
            default:
              this.$store.commit(
                "showError",
                this.$t("local.msg.technical_error")
              );
          }
        });
    },
  },
};
</script>

<style scoped>
.right {
  background: #333 !important;
}
</style>
